"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaccinationReviewStatus = void 0;
exports.instanceOfVaccinationReviewStatus = instanceOfVaccinationReviewStatus;
exports.VaccinationReviewStatusFromJSON = VaccinationReviewStatusFromJSON;
exports.VaccinationReviewStatusFromJSONTyped = VaccinationReviewStatusFromJSONTyped;
exports.VaccinationReviewStatusToJSON = VaccinationReviewStatusToJSON;
exports.VaccinationReviewStatusToJSONTyped = VaccinationReviewStatusToJSONTyped;
/**
 *
 * @export
 */
exports.VaccinationReviewStatus = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
};
function instanceOfVaccinationReviewStatus(value) {
    for (const key in exports.VaccinationReviewStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.VaccinationReviewStatus, key)) {
            if (exports.VaccinationReviewStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function VaccinationReviewStatusFromJSON(json) {
    return VaccinationReviewStatusFromJSONTyped(json, false);
}
function VaccinationReviewStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function VaccinationReviewStatusToJSON(value) {
    return value;
}
function VaccinationReviewStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=VaccinationReviewStatus.js.map